import { render, staticRenderFns } from "./IndexingStudents.vue?vue&type=template&id=fc157efc&"
import script from "./IndexingStudents.vue?vue&type=script&lang=js&"
export * from "./IndexingStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports